import { render, staticRenderFns } from "./ImportRideDocuments.vue?vue&type=template&id=9f715afe&scoped=true"
import script from "./ImportRideDocuments.vue?vue&type=script&lang=js"
export * from "./ImportRideDocuments.vue?vue&type=script&lang=js"
import style0 from "./ImportRideDocuments.vue?vue&type=style&index=0&id=9f715afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f715afe",
  null
  
)

export default component.exports